import axios from "axios";

// Locally the CRA dev server proxies /api to the FastAPI backend (see "proxy" in
// package.json). On the server nginx does the same, so the default is same-origin.
const API_URL = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(error) {
  if (!error?.response) return "Can't reach the server. Is the backend running?";
  const detail = error.response.data?.detail;
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
